import { createStore, applyMiddleware, Store, Action, Middleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import reducers from '../reducers'
import rootSaga from '../sagas'
import configureAxios from 'lib/AxiosInterceptors'
import { RootState } from 'model/state';
import { sessionInactiveMiddleware } from 'middleware/sessionInactive'

const sagaMiddleware = createSagaMiddleware()

export interface StoreExt {
  runSagaTask: () => void;
  sagaTask: any
}

let store: Store<RootState, Action> & StoreExt;

function bindMiddleware<C extends object>(middleware: Middleware<C, RootState>[]) {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('redux-devtools-extension')
    return composeWithDevTools(applyMiddleware(...middleware))
  }
  return applyMiddleware(...middleware)
}

export function configureStore() {
  store = createStore(
    reducers,
    bindMiddleware([sagaMiddleware, sessionInactiveMiddleware])
  )

  store.runSagaTask = () => {
    store.sagaTask = sagaMiddleware.run(rootSaga)
  }

  store.runSagaTask()

  configureAxios(store);

  return store
}

export function getStore() {
  return store;
}

export default configureStore;